<template>
    <div class="fieldset">
        <text-headline-secondary>
            {{ title }}
        </text-headline-secondary>

        <p>
            {{ description }}
        </p>

        <div class="row">
            <div class="field">
                <field-customer-delivery-name :validate="validate" />
            </div>
        </div>

        <div class="row">
            <div class="field">
                <field-customer-delivery-address :validate="validate" />
            </div>
        </div>

        <div class="row">
            <div class="field">
                <field-customer-delivery-zip :validate="validate" />
            </div>
            <div class="field">
                <field-customer-delivery-city :validate="validate" />
            </div>
        </div>
    </div>
</template>

<script>
import FieldCustomerDeliveryName from "@/components/fields/FieldCustomerDeliveryName";
import FieldCustomerDeliveryAddress from "@/components/fields/FieldCustomerDeliveryAddress";
import FieldCustomerDeliveryCity from "@/components/fields/FieldCustomerDeliveryCity";
import FieldCustomerDeliveryZip from "@/components/fields/FieldCustomerDeliveryZip";

export default {
    name: "FieldsetCustomerAddress",
    components: {
        FieldCustomerDeliveryName,
        FieldCustomerDeliveryAddress,
        FieldCustomerDeliveryCity,
        FieldCustomerDeliveryZip
    },
    props: {
        validate: { type: Boolean, default: false },
        title: { type: String, required: true },
        description: { type: String, required: true }
    }
};
</script>

<style scoped lang="scss">
.field {
    margin-bottom: 1rem;
}

@media (min-width: $breakpoint-tablet) {
    .row {
        display: flex;
    }

    .field {
        margin-bottom: 1.5rem;
    }

    .row .field {
        flex: 1 1 0px;
    }

    .row .field + .field {
        margin-left: 1.5rem;
    }
}
</style>
